var map = {
	"./BC_MinistryofAg_logo.png": 41,
	"./MGEM_logo.jpg": 42,
	"./animated_ashutosh.png": 43,
	"./animated_logo.svg": 44,
	"./blogs_image.svg": 45,
	"./cloud_infrastructure.svg": 46,
	"./codeInLogo.png": 47,
	"./coursera_logo.png": 48,
	"./data_science.svg": 49,
	"./developerActivity.svg": 50,
	"./dsc_logo.png": 51,
	"./education.svg": 52,
	"./experience.svg": 53,
	"./feelingProud.svg": 54,
	"./fme_form_basic_logo.png": 55,
	"./freecopy_logo.png": 56,
	"./fullstack.svg": 57,
	"./gcp_logo.png": 58,
	"./github_logo.png": 59,
	"./googleAssistant.jpg": 60,
	"./googleAssistant.svg": 61,
	"./google_logo.png": 62,
	"./ibm_logo.png": 63,
	"./jsFramework.svg": 64,
	"./logo.png": 26,
	"./manOnTable.svg": 65,
	"./microsoft_logo.png": 66,
	"./mozilla_logo.png": 67,
	"./muffito_logo.png": 68,
	"./nextuLogo.jpg": 69,
	"./nptel_logo.png": 70,
	"./portfolio.gif": 71,
	"./programmer.svg": 72,
	"./pwa.png": 73,
	"./pwsbc_logo.jpg": 74,
	"./saayaHealthLogo.png": 75,
	"./talksCardBack.svg": 76,
	"./talksCardBackAlt.svg": 77,
	"./ua_logo_green_rgb.png": 78,
	"./ubc_logo.png": 79,
	"./ui_ux_design.svg": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;